/**
 * Returns the atom type from nucleus.
 * @param {string} nucleus
 */
export function getAtomTypeFromNucleus(nucleus) {
    return nucleus.length > 0 ? nucleus.split(/\d+/)[1] : '';
}
//# sourceMappingURL=getAtomTypeFromNucleus.js.map